import script from "./ReportFormsPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportFormsPreview.vue?vue&type=script&setup=true&lang=js"

import "./ReportFormsPreview.vue?vue&type=style&index=0&id=14acb9de&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/u.xiansuotu.com/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14acb9de"]])

export default __exports__